import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "carousel-wrapper" }
const _hoisted_2 = { class: "bs-container" }
const _hoisted_3 = { class: "bs-row justify-content-center" }
const _hoisted_4 = { class: "c c-lg-12 carousel-title" }
const _hoisted_5 = { class: "carousel-title__name" }
const _hoisted_6 = { class: "carousel-container" }
const _hoisted_7 = { class: "carousel-blur left" }
const _hoisted_8 = { class: "bs-container" }
const _hoisted_9 = { class: "bs-row justify-content-center" }
const _hoisted_10 = { class: "c c-lg-12" }
const _hoisted_11 = { class: "carousel-blur right" }

import { ref } from "vue";
import SyndicateCard from "./syndicate-card.vue";
import { KeenSliderInstance } from "keen-slider";
import { useKeenSlider } from "keen-slider/vue.es";
import { SyndicatePreview } from "@/lotteries/model/syndicates/syndicate-preview";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'bets-carousel',
  props: {
    title: {},
    data: {}
  },
  setup(__props: any) {



const current = ref(0);

const [carouselRef, carousel] = useKeenSlider<HTMLDivElement>({
    slides: {
        perView: 1.2,
    },
    breakpoints: {
        /* eslint-disable */
        "(min-width: 366px)": {
            slides: {
                perView: 1.5,
            },
        },
        "(min-width: 541px)": {
            slides: {
                perView: 2,
            },
        },
        "(min-width: 1221px)": {
            slides: {
                perView: 3,
            },
        },
    },
    slideChanged: (s: KeenSliderInstance) => {
        current.value = s.track.details.abs;
    },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "carousel-title__link" }, [
            _createElementVNode("a", {
              href: "trziste-sazenek",
              class: "btn btn-link ico-a-arrow-right"
            }, "všechny")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DsButton, {
          class: _normalizeClass([{ 'carousel-button--disabled': current.value === 0 }, "carousel-button carousel-button--prev"]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(carousel).prev())),
          "icon-left": "arrow-left",
          "aria-label": "Předešlý slide"
        }, null, 8, ["class"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "bs-row keen-slider",
              ref_key: "carouselRef",
              ref: carouselRef
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (bet, i) => {
                return (_openBlock(), _createBlock(SyndicateCard, {
                  data: bet,
                  key: i,
                  carouselCard: true
                }, null, 8, ["data"]))
              }), 128))
            ], 512)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_unref(carousel))
          ? (_openBlock(), _createBlock(DsButton, {
              key: 0,
              class: _normalizeClass(["carousel-button carousel-button--next", {
                        'carousel-button--disabled': current.value >= _unref(carousel)?.track.details?.maxIdx,
                    }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(carousel).next())),
              "icon-right": "arrow-right",
              "aria-label": "Následujicí slide"
            }, null, 8, ["class"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})